import React, { useEffect, useState } from 'react';
import { Pencil, Check, X } from 'lucide-react';

// Click-to-rename text; Enter saves, Escape cancels.
export default function InlineEdit({ value, onSave, canEdit, className = '', testId }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  useEffect(() => { setDraft(value); }, [value]);
  const commit = async () => {
    const v = draft.trim();
    if (!v || v === value) { setEditing(false); setDraft(value); return; }
    if (await onSave(v)) setEditing(false);
  };
  if (!editing) {
    return (
      <span className={`inline-flex items-center gap-1.5 min-w-0 ${className}`}>
        <span className="truncate" data-testid={testId}>{value}</span>
        {canEdit && (
          <button type="button" onClick={() => setEditing(true)} aria-label="Rename" className="p-1 rounded text-[#94A3B8] hover:text-[#1A3E6F] hover:bg-[#F1F5F9] opacity-60 hover:opacity-100 transition-opacity" data-testid={`${testId}-edit`}>
            <Pencil className="w-3 h-3" />
          </button>
        )}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 min-w-0 flex-1">
      <input autoFocus value={draft} maxLength={80} onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') { setEditing(false); setDraft(value); } }}
        className="h-8 min-w-0 flex-1 rounded-md border border-[#1A3E6F]/40 px-2 text-sm text-[#0F172A] focus:outline-none focus:ring-2 focus:ring-[#1A3E6F]/20" data-testid={`${testId}-input`} />
      <button type="button" onClick={commit} aria-label="Save" className="p-1.5 rounded text-[#1F684A] hover:bg-[#EDF8F2]" data-testid={`${testId}-save`}><Check className="w-3.5 h-3.5" /></button>
      <button type="button" onClick={() => { setEditing(false); setDraft(value); }} aria-label="Cancel" className="p-1.5 rounded text-[#94A3B8] hover:bg-[#F1F5F9]"><X className="w-3.5 h-3.5" /></button>
    </span>
  );
}
